import { IntegrationDefinition } from '../IntegrationDefinition';
import { cloneDeep } from 'lodash';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import { YardiCommercialProperties } from '../../constants/integrations/Yardi';

const definition: IntegrationDefinition = {
  name: IntegrationProviderEnum.YardiCommercial,
  hasCustomUI: true,
  friendlyName: IntegrationProviderEnum.YardiCommercial,
  description: `Defines the properties required for Yardi Commercial integration.`,
  category: IntegrationCategoryEnum.Displays,
  platforms: [],
  type: IntegrationTypeEnum.Api,
  settings: {},
  properties: cloneDeep(YardiCommercialProperties),
};

export { definition };
